import { render, staticRenderFns } from "./SupplyingCreateEdit.vue?vue&type=template&id=56bda890"
import script from "./SupplyingCreateEdit.vue?vue&type=script&lang=js"
export * from "./SupplyingCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports